module.exports = __webpack_public_path__ + "static/media/mz.e8801c33.svg";